import React from 'react';

import { AthleteFocus, Attendants, Banner, EventCountdown, Partners } from './components';

const Events = (props) => {
  return (
    <React.Fragment>
      <Banner />
      <Attendants />
      <AthleteFocus />
      <EventCountdown />
      <Partners />
    </React.Fragment>
  );
};

export default Events;
